import AiSecurityExperience from '@comp/ai/ai-security-experience'

export default function AiSecurityPage({ locale }: { locale: string }) {
  return <AiSecurityExperience page="overview" locale={locale} />
}

export async function getStaticProps({ locale }: { locale: string }) {
  return { props: { locale: locale ?? 'en' } }
}
